export const Api_Url = `https://api.thrones.co.in`
